// ต้องติดตั้ง: npm i qrcode
import React from "react";

const useQRCode = () => {
  const QR = React.useRef(null);
  const loadingPromise = React.useRef(null);

  React.useEffect(() => {
    if (!loadingPromise.current) {
      loadingPromise.current = (async () => {
        const mod = await import("qrcode");
        QR.current = mod;
      })().catch((e) => {
        console.error("Missing dependency 'qrcode'. Please install it:", e);
      });
    }
  }, []);

  const ensure = async () => {
    if (loadingPromise.current) {
      await loadingPromise.current;
    }
    if (!QR.current) throw new Error("โมดูล 'qrcode' ยังไม่พร้อมใช้งาน");
    return QR.current;
  };

  const generateOnCanvas = async (canvas, opts) => {
    if (!canvas) return;
    const qrcode = await ensure();

    // สร้าง QR บน canvas
    await qrcode.toCanvas(canvas, opts.text, {
      width: opts.width,
      margin: opts.margin,
      color: opts.color,
      errorCorrectionLevel: opts.errorCorrectionLevel,
    });

    // ถ้ามีโลโก้: รอโหลดรูปแล้ววาดทับตรงกลาง
    if (opts.logoDataUrl) {
      await drawLogoOnCanvas(canvas, opts.logoDataUrl, opts.width);
    }
  };

  const toPngDataUrl = async (opts) => {
    // เรนเดอร์ลง canvas ชั่วคราว แล้วคืน dataURL (รอโลโก้เรียบร้อย)
    const canvas = document.createElement("canvas");
    canvas.width = opts.width;
    canvas.height = opts.width;
    await generateOnCanvas(canvas, opts);
    return canvas.toDataURL("image/png");
  };

  return {
    generateOnCanvas,
    toPngDataUrl,
  };
};

export default useQRCode;

// ===== helpers =====
function drawLogoOnCanvas(canvas, logoDataUrl, totalSize) {
  return new Promise((resolve, reject) => {
    try {
      const ctx = canvas.getContext("2d");
      const size = Math.floor(totalSize * 0.2); // 20% ของขนาด QR
      const img = new Image();
      img.onload = () => {
        const x = (totalSize - size) / 2;
        const y = (totalSize - size) / 2;
        const r = 12;
        ctx.save();
        ctx.fillStyle = "#ffffff";
        roundRect(ctx, x - 6, y - 6, size + 12, size + 12, r);
        ctx.fill();
        ctx.drawImage(img, x, y, size, size);
        ctx.restore();
        resolve();
      };
      img.onerror = reject;
      img.src = logoDataUrl;
    } catch (e) {
      reject(e);
    }
  });
}

function roundRect(ctx, x, y, width, height, radius = 6) {
  if (typeof radius === "number")
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radius.br,
    y + height
  );
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
}
